module.exports = __webpack_public_path__ + "static/media/erkmenesen4.61ba32e9.jpg";